import { useCallback, useEffect, useRef, useState } from 'react'
import catRunningBgm from './game/bgm'

export default function useCatRunningBgm({ shouldPlay, worldRef }) {
  const [muted, setMuted] = useState(() => catRunningBgm.loadMutedPreference())
  const lastPlayingStageKeyRef = useRef(null)

  useEffect(() => {
    catRunningBgm.preload()
    return () => {
      catRunningBgm.stop()
    }
  }, [])

  useEffect(() => {
    catRunningBgm.setMuted(muted)
  }, [muted])

  useEffect(() => {
    if (!shouldPlay || !worldRef) {
      catRunningBgm.stop()
      lastPlayingStageKeyRef.current = null
      return undefined
    }

    lastPlayingStageKeyRef.current = null

    let frameId = 0

    const syncStageBgm = () => {
      const stageKey = worldRef.current?.stageKey
      if (stageKey && stageKey !== lastPlayingStageKeyRef.current) {
        catRunningBgm.playStage(stageKey).then((didPlay) => {
          if (didPlay) {
            lastPlayingStageKeyRef.current = stageKey
          }
        })
      }

      frameId = window.requestAnimationFrame(syncStageBgm)
    }

    syncStageBgm()

    return () => {
      window.cancelAnimationFrame(frameId)
    }
  }, [shouldPlay, worldRef])

  const unlockFromUserGesture = useCallback(() => {
    if (muted) return

    const stageKey = worldRef.current?.stageKey
    if (!stageKey) return

    lastPlayingStageKeyRef.current = null
    catRunningBgm.playStage(stageKey).then((didPlay) => {
      if (didPlay) {
        lastPlayingStageKeyRef.current = stageKey
      }
    })
  }, [muted, worldRef])

  const toggleMuted = useCallback(() => {
    setMuted((current) => {
      const next = !current
      catRunningBgm.setMuted(next).then((didPlay) => {
        if (didPlay) {
          lastPlayingStageKeyRef.current = worldRef.current?.stageKey ?? null
        }
      })
      return next
    })
  }, [worldRef])

  return {
    muted,
    toggleMuted,
    unlockFromUserGesture,
  }
}
